/**
 * UI Molecules Stubs - Temporary implementations
 * 
 * These are placeholder implementations for missing @ferp/ui-molecules package
 * components until the full design system is implemented.
 */

import React from 'react';
import { BaseComponentProps } from './ui-foundation-stubs';

export interface FerpStatusCardProps extends BaseComponentProps {
  title: string;
  value: string | number;
  status: 'success' | 'warning' | 'error' | 'info' | 'completed' | 'active';
  subtitle?: string;
  icon?: React.ReactNode;
  description?: string;
  previousValue?: number;
  showTrend?: boolean;
  statusColor?: string;
  criticality?: string;
  isLifeCritical?: boolean;
  actions?: any[];
}

export const FerpStatusCard: React.FC<FerpStatusCardProps> = ({
  title,
  value,
  status,
  subtitle,
  icon,
  className,
  ...props
}) => {
  return (
    <div className={`ferp-status-card ferp-status-card--${status} ${className || ''}`} {...props}>
      <div className="ferp-status-card__header">
        {icon && <span className="ferp-status-card__icon">{icon}</span>}
        <h3 className="ferp-status-card__title">{title}</h3>
      </div>
      <div className="ferp-status-card__value">{value}</div>
      {subtitle && <div className="ferp-status-card__subtitle">{subtitle}</div>}
    </div>
  );
};

export interface FerpBreadcrumbsProps extends BaseComponentProps {
  items: Array<{
    label: string;
    href?: string;
    active?: boolean;
  }>;
  emergencyMode?: boolean;
  mb?: string;
}

export const FerpBreadcrumbs: React.FC<FerpBreadcrumbsProps> = ({
  items,
  className,
  ...props
}) => {
  return (
    <nav className={`ferp-breadcrumbs ${className || ''}`} {...props}>
      {items.map((item, index) => (
        <span key={index} className={`ferp-breadcrumbs__item ${item.active ? 'active' : ''}`}>
          {item.href ? (
            <a href={item.href}>{item.label}</a>
          ) : (
            item.label
          )}
          {index < items.length - 1 && <span className="ferp-breadcrumbs__separator">/</span>}
        </span>
      ))}
    </nav>
  );
};